<template>
    <div>
        <div class="overflow-hidden" v-if="imagem">
            <div class="bg-cover bg-center w-full h-screen"
                :style="{ backgroundImage: `url(data:image/PNG;base64,${imagem})` }">
                <CredenciamentoCpf></CredenciamentoCpf>
            </div>
        </div>
        <div v-if="!imagem">
            <CredenciamentoCpf></CredenciamentoCpf>
        </div>
    </div>
</template>

<script>
import CredenciamentoCpf from './CredenciamentoCpf.vue';
import Services from './services.js'

export default {
    components: {
        CredenciamentoCpf
    },

    data: () => ({
        imagem: null
    }),

    computed: {
        modoTouchscreen() {
            return this.$route.query.modo === 'touchscreen';
        },
    },

    methods: {
        obterImagemCredenciamento() {
            this.$store.dispatch('addRequest');
            Services.obterImagemCredenciamento(this.$route.query.evento).then((response) => {
                if (response?.success) {
                    this.imagem = response.data;
                } else {
                    this.imagem = null;
                }
            }).finally(() => {
                this.$store.dispatch('removeRequest');
            })
        },
        bloquearContexto(e) {
            e.preventDefault();
        },
        bloquearSelecao(e) {
            e.preventDefault();
        },
    },

    mounted() {
        if (this.$route.query.evento) {
            this.obterImagemCredenciamento();
        }
        if (this.modoTouchscreen) {
            document.addEventListener('contextmenu', this.bloquearContexto);
            document.addEventListener('selectstart', this.bloquearSelecao);
            // Folha de estilo com !important cobrindo TODOS os elementos — o
            // user-select no body sozinho era sobrescrito por regras mais específicas.
            this._estiloQuiosque = document.createElement('style');
            this._estiloQuiosque.textContent =
                '*,*::before,*::after{-webkit-user-select:none!important;user-select:none!important;-webkit-touch-callout:none!important;}';
            document.head.appendChild(this._estiloQuiosque);
            document.body.style.touchAction = 'manipulation'; // desativa duplo-toque-zoom
        }
    },
    unmounted() {
        document.removeEventListener('contextmenu', this.bloquearContexto);
        document.removeEventListener('selectstart', this.bloquearSelecao);
        if (this._estiloQuiosque && this._estiloQuiosque.parentNode) {
            this._estiloQuiosque.parentNode.removeChild(this._estiloQuiosque);
        }
        document.body.style.touchAction = '';
    },
}
</script>